import Vue from 'vue';
import store from '../../store/store';
import onboardingService from './onboardingService';
import userOnboardingConstants from '../config/userOnboardingConstants';

class UserOnboardingService {
    tutorial = {
        advertisement: 'advertisement',
        createLink: 'create_link',
    };

    status = {
        completed: 'completed',
        skip: 'skip',
        hold: 'hold',
        processing: 'processing',
        start: 'start',
    };

    /**
     * To get config list in constant file config and return
     */
    get configs() {
        return userOnboardingConstants;
    }

    /**
     * To check in store the onboarding has allow
     * @returns {Boolean}
     */
    hasOnboarding() {
        return store.state.vueOnboarding.hasOnboarding;
    }

    currentFlow() {
        return store.state.vueOnboarding.flow;
    }

    async skip(data = { welcome: false, tutorial: false }) {
        if (!onboardingService.hasOnboarding()) return;

        try {
            const res = await Vue.axios.post('/user-onboarding/skip', data);

            onboardingService.setSkip(true);

            return res.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Send holding process onboarding
     *
     * @param {{  step: number, tutorial: 'advertisement' | 'create_link' }} data
     * @returns
     */
    async hold(data = {}, setStateHolding = true) {
        if (!onboardingService.hasOnboarding()) return;

        try {
            const res = await Vue.axios.post('/user-onboarding/hold', data);

            onboardingService.setHolding(setStateHolding);

            return res.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Get process onboarding of user
     * @returns
     */
    async trackingProcess() {
        try {
            const res = await Vue.axios.post('/user-onboarding/tracking-process');
            const { data } = res.data;

            const shouldOnboardingCauseNotComplete = data.onboarding.status === this.status.completed || data.onboarding.flow === "NA";
            const onBoardingSkipped = data.onboarding.status === this.status.skip;
            onboardingService.setHasOnboarding(true);
            onboardingService.setCompleteAll(shouldOnboardingCauseNotComplete);
            onboardingService.setSkip(onBoardingSkipped);

            return data;
        } catch (e) {
            onboardingService.setHasOnboarding(false);

            return Promise.reject(e);
        }
    }

    /**
     * To send request complete a onboarding
     *
     * @param {{ step: number, tutorial: String }} data
     * @returns
     */
    async complete(data = { step, tutorial }) {
        if (!onboardingService.hasOnboarding()) return;

        try {
            window.onbeforeunload = () => {};
            window.onunload = () => {};

            const res = await Vue.axios.post('/user-onboarding/complete', data);

            this.onEmitCompleted(res.data.data);

            return res.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * To send request complete a onboarding
     *
     * @param {{ step: number, tutorial: String }} data
     * @returns
     */
    async completeAll() {
        if (!onboardingService.hasOnboarding()) return;

        try {
            const res = await Vue.axios.post('/user-onboarding/complete-all');

            return res.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Send request to count times closing reminder
     *
     * @returns
     */
    async closeReminder() {
        if (!onboardingService.hasOnboarding()) return;

        try {
            const res = await Vue.axios.post('/user-onboarding/close-reminder');
            return res.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    onEmitCompleted(data = {}) {
        Vue.prototype.$bus.$emit('user-onboarding-service-emit-complete', data);
    }

    onListenCompleted(callback = () => {}) {
        Vue.prototype.$bus.$on('user-onboarding-service-emit-complete', callback);
    }
}

const userOnboardingService = new UserOnboardingService();

export default userOnboardingService;



// WEBPACK FOOTER //
// ./src/core/services/userOnboardingService.js